import React from 'react';


class OrderModal extends React.Component {

  render(props) {
    return <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="mdc-snackbar">
        <div class="mdc-snackbar__surface">
          <div class="mdc-snackbar__label"
            role="status"
            aria-live="polite" id="modalSnackbar">
            На Вашем балансе недостаточно средств
    </div>
          <div class="mdc-snackbar__actions">
            <button type="button" class="mdc-button mdc-snackbar__action">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label">Закрыть</span>
            </button>
          </div>
        </div>
      </div>

     

      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div style={{ background: "rgb(98, 0, 238)", width: "100%", height: "0%", maxHeight: "100%", borderRadius: "12px", zIndex: "999999", display: "inline-flex", position: "absolute", transition: "height 1s ease-out 0s", bottom: "0px", alignItems: "center" }} id="nbg">
            <div class="success-checkmark" style={{ opacity: 0, display: "none" }}>
              <div class="check-icon" style={{ display: "none" }}>
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>

            <div className="orderInfo">
              <h4 style={{ marginBottom: "8px" }}>Заказ оплачен</h4>

              <table className="orderInfoTable">
                <tbody>
                  <tr><td className="orderInfoTableKey">ID заказа</td><td className="orderInfoTableValue" id="oiOID">157</td></tr>
                  <tr><td className="orderInfoTableKey">Сумма</td><td className="orderInfoTableValue" id="oiTotal">10$</td></tr>
                  <tr><td className="orderInfoTableKey">Ваш баланс</td><td className="orderInfoTableValue" id="oiBalance">120$</td></tr>
                </tbody>
              </table>

            </div>
          </div>

          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">Новый заказ</h5>
          </div>
          <div className="modal-body">

            <div style={{ textAlign: "center", marginBottom: "16px" }}>
              <h4 className="modal-title" id="modalTitle">Telegram - Подписчики</h4>
            </div>

            <div style={{ textAlign: "left", marginBottom: "8px", paddingLeft: "16px", paddingRight: "25px" }} id="modalDescr">

            </div>

            <div style={{ textAlign: "left", marginBottom: "16px", paddingLeft: "16px", paddingRight: "25px", display: 'flex' }}><b>❗️ Повторно заказывать услугу на ту же ссылку можно только после полного её выполнения</b></div>

            <div style={{ textAlign: "left", marginBottom: "16px", paddingLeft: "16px", paddingRight: "25px", display: 'flex' }}><b>ID сервиса: &nbsp;</b><div id="sidField"></div></div>

            <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-leading-icon" id="urlField" style={{ width: "100%" }}>
              <i className="fas fa-link mdc-text-field__icon mdc-text-field__icon--leading" style={{ marginLeft: "15px", marginRight: "10px", color: "rgba(255,255,255,.77)" }}></i>
              <input type="text" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id="linkInput" />
              <span class="mdc-notched-outline">
                <span class="mdc-notched-outline__leading"></span>
                <span class="mdc-notched-outline__notch">
                  <span class="mdc-floating-label" id="modalLabelLink">Ссылка на канал</span>
                </span>
                <span class="mdc-notched-outline__trailing"></span>
              </span>
            </label>

            <div style={{ display: "flex" }}>
              <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-leading-icon" id="colField" style={{ width: "50%", display: "inline-flex", marginRight: "5px", marginTop: "4px" }}>
                <i className="fas fa-user mdc-text-field__icon mdc-text-field__icon--leading" style={{ marginLeft: "15px", marginRight: "10px", color: "rgba(255,255,255,.77)" }}></i>
                <input type="text" class="mdc-text-field__input" aria-labelledby="colLabel" id="colInput" autocomplete="off" onKeyPress={
                  (event) => {
                    var theEvent = event || window.event
                    console.log(theEvent)
                    var key = theEvent.keyCode || theEvent.which
                    key = String.fromCharCode(key)
                    var regex = /[0-9]|\./
                    if (!regex.test(key) || document.querySelector('#colInput').value.length > 5) {
                      theEvent.returnValue = false
                      if (theEvent.preventDefault) theEvent.preventDefault()
                    }
                  }} />
                <span class="mdc-notched-outline">
                  <span class="mdc-notched-outline__leading"></span>
                  <span class="mdc-notched-outline__notch">
                    <span class="mdc-floating-label" id="colLabel" >Количество</span>
                  </span>
                  <span class="mdc-notched-outline__trailing"></span>
                </span>
              </label>

              <label className="mdc-text-field mdc-text-field--outlined mdc-text-field--fullwidth mdc-text-field--label-floating" id="priceField" style={{ width: "50%", display: "inline-flex", marginTop: "4px", marginLeft: "5px" }}>
                <i className="fas fa-tag" style={{ marginLeft: "10px", marginRight: "10px", color: "rgba(255,255,255,.77)" }}></i>
                <input className="mdc-text-field__input" id="modalPrice" type="text" placeholder="Цена" aria-label="Цена" value="0.1$" />
                <span class="mdc-notched-outline mdc-notched-outline--upgraded mdc-notched-outline--notched">
                  <span class="mdc-notched-outline__leading"></span>
                  <span class="mdc-notched-outline__notch">
                    <span class="mdc-floating-label mdc-floating-label--float-above" id="pricelLabel" style={{ display: "inline-block" }}>Цена</span>
                  </span>
                  <span class="mdc-notched-outline__trailing"></span>
                </span>
              </label>
            </div>
            <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-leading-icon" id="totalField" style={{ width: "100%", marginTop: "4px" }}>
              <i className="fas fa-money-check-alt mdc-text-field__icon mdc-text-field__icon--leading" style={{ marginLeft: "15px", marginRight: "10px", color: "rgba(255,255,255,.77)" }}></i>
              <input type="text" id="totalInput" autocomplete="off" class="mdc-text-field__input" aria-labelledby="totalLabel" aria-label="Label" onKeyPress={
                (event) => {
                  var theEvent = event || window.event
                  console.log(theEvent)
                  var key = theEvent.keyCode || theEvent.which
                  key = String.fromCharCode(key)
                  var regex = /[0-9]|\./
                  if (!regex.test(key)) {
                    theEvent.returnValue = false
                    if (theEvent.preventDefault) theEvent.preventDefault()
                  }
                }} />
              <span class="mdc-text-field__affix mdc-text-field__affix--suffix">$</span>
              <span class="mdc-notched-outline">
                <span class="mdc-notched-outline__leading"></span>
                <span class="mdc-notched-outline__notch">
                  <span class="mdc-floating-label" id="totalLabel">Итого</span>

                </span>
                <span class="mdc-notched-outline__trailing"></span>
              </span>
            </label>

            <button class="mdc-button mdc-button--raised mdc-ripple-upgraded" id="orderBtn" style={{ width: "100%", height: "56px", marginTop: "4px" }}>
              <div class="mdc-button__ripple"></div>
              <i className="fas fa-shopping-cart"></i>
              <span className="mdc-button__label">&nbsp;&nbsp;Заказать</span>
            </button>
          </div>

        </div>
      </div>

      <div id="cardService" style={{ width: 0, height: 0, visibility: "hidden" }}>

      </div>

    </div>
  }
}

export default OrderModal